import * as React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { useState, useEffect } from 'react';
import './home.css';
import { useGlobal } from '../../utils/GlobalContext';
import { newSession, session } from '../../data/session';
import SpeakerInfoModal from '../common/SpeakerInfoModal';
import { SessionInfo, SessionSpeaker, newSessionInfo } from '../../data/SessionData';
import { UserProfile, newUserProfile } from '../../data/userProfile';
import SessionInfoModal from '../common/SessionInfoModal';
import { Session } from 'inspector';

export default function PreviousKeynoteComponent() {
    const { state } = useGlobal();
    //Filter for keynote sessions
    const [pastKeynotes, setPastKeynotes] = useState<session[]>();
    useEffect(()=>{
        if(state.Conference?.Keynotes.length!==0 && pastKeynotes?.length===undefined){
            const tempPastKeynotes: session[] = state.Conference?.Keynotes.filter(function (el) {
                return el.EventId!== state.Conference?.CurrentEventId;
            });
            setPastKeynotes(tempPastKeynotes);
        }
    });
    // Speaker Modal Hookup
    const [speakerInfoOpen, setSpeakerInfoOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState<UserProfile>(newUserProfile());
    const handleSpeakerModalOpen = (speaker: SessionSpeaker) => {
        const tempSelectedSpeaker: UserProfile[] = state.Profiles.filter(function (el){
            return el.Id=== speaker.UserId;
        });
        setSelectedSpeaker(tempSelectedSpeaker[0]);
        setSpeakerInfoOpen(true);
    };
    const handleSpeakerModalClose = () => {
        setSpeakerInfoOpen(false);
    };
    // Session Modal Hookup
    const [sessionInfoOpen, setSessionInfoOpen] = useState(false);
    const [selectedSession, setSelectedSession] = useState<session>(newSession());
    const handleSessionModalOpen = (sessionData: session) => {
        setSelectedSession(sessionData);
        setSessionInfoOpen(true);
    };
    const handleSessionModalClose = () => {
        setSessionInfoOpen(false);
    };
    return (
        <>
            {pastKeynotes?.length===0 || pastKeynotes===undefined? (<div></div> ) : (
            <>
                <center className='topSpacer36px'>
                    <h4 className='textAccentColor2 uppercase'>Previous Years Keynote Videos</h4>
                    <h4 className='thin'>Get inspired by previous keynotes from previous {state.Conference.Name}.</h4>
                </center>
            
                {
                    <>
                    <Grid sx={{ flexGrow: 1 }} container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justifyContent="center" spacing={2}>
                                {pastKeynotes?.map((keynote) => (
                                <Grid key={keynote.Id} item>
                                    <Card elevation={5}
                                        sx={{
                                            height: 240,
                                            width: 410,
                                            backgroundColor: (theme) =>
                                            theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
                                        }
                                    }
                                    >
                                        <Card>
                                            <div className="PrevKeynoteContainer">
                                                <div className="PrevKeynoteContainer-small-images">
                                                    {keynote.SessionSpeakers.map((keynoter)=>(
                                                            <div>
                                                            <img className='KeynoteSpeakerImage' onClick={()=>handleSpeakerModalOpen(keynoter)}
                                                                src={keynoter.PictureLink===null?
                                                                    "https://internationalwomensday.s3-us-west-2.amazonaws.com/images/IWD-WomenSpeakers.jpg"
                                                                    :keynoter.PictureLink} 
                                                                title={keynoter.SpeakerName} alt=""/>
                                                            </div>
                                                        )
                                                    )}
                                                    <a onClick={()=>handleSessionModalOpen(keynote)}>
                                                        <img className='KeynoteInfo' src="https://cdn-icons-png.flaticon.com/128/5393/5393011.png" title="Info" alt=""/>
                                                    </a>
                                                </div>
                                                <a className="PrevKeynoteContainer-big-image" href={`${keynote.VideoLink}`}>
                                                    <img src={keynote.VideoThumbnail} title={keynote.Description} alt=""/>
                                                    <div className='PrevKeynotePlayButton'>
                                                        <img src="keynote_play_icon.png" title="Play" alt=""/>
                                                    </div>
                                                    <div className='PrevKeynoteTitle'>
                                                        <h4>{keynote.Title}</h4>
                                                    </div>
                                                </a>
                                            </div>
                                        </Card>
                                    </Card>
                                </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                    <SpeakerInfoModal show={speakerInfoOpen} onClose={handleSpeakerModalClose} speaker={selectedSpeaker}/>
                    <SessionInfoModal show={sessionInfoOpen} onClose={handleSessionModalClose} sessionModel={selectedSession}/>
                    </>
                }
            </>
        )}
        </>
    )
}